import { Observable, Subject } from 'rxjs'

export class AuthStatusService {
  public onAuthError$: Observable<void>
  private authErrorSubject: Subject<void>

  constructor() {
    this.authErrorSubject = new Subject<void>()
    this.onAuthError$ = this.authErrorSubject.asObservable()
  }

  public triggerAuthError(): void {
    this.authErrorSubject.next()
  }
}
